/**
 * Render a stored event date as the fixed, human-readable `DD.MM.YYYY` format used across the
 * Event-outreach UI, the variable preview and the inline message preview (PREC-3539). Accepts both
 * the locally-saved `"yyyy-MM-dd"` form and the API's full ISO datetime (`"2026-07-06T00:00:00.000Z"`).
 *
 * Formatted in UTC so a date stored at midnight UTC never drifts a day in a behind-UTC timezone —
 * kept in lockstep with the backend `formatEventDate` in
 * `apps/api/src/schedule/utils/event-variables.util.ts`.
 */
export const formatEventDate = (value?: string | null): string => {
	if (!value) {
		return "";
	}

	const date = new Date(value);

	if (Number.isNaN(date.getTime())) {
		return "";
	}

	const day = String(date.getUTCDate()).padStart(2, "0");
	const month = String(date.getUTCMonth() + 1).padStart(2, "0");

	return `${day}.${month}.${date.getUTCFullYear()}`;
};
